import request from '@/plugins/axios';

/**
 * @description 获取用户是否同意了该课程的社群协议
 * @param {number} seriesId 课程ID
 * @returns {Promise}
 */
export const getProtocolInfo = seriesId => request({
  method: 'get',
  url: '/api/lesson/camp/user_contract',
  params: {
    series_id: seriesId
  }
});

/**
 * @description 用户是否同意协议
 * @param {number} seriesId 课程ID
 * @param {number} agree 0 不同意，1 同意
 * @returns
 */
export const setProtocolInfo = (seriesId, agree = 1) => request({
  method: 'post',
  url: '/api/lesson/camp/agree_contract',
  data: {
    series_id: seriesId,
    agree
  }
});
